import { GET_ASSIGNMENT_HISTORY } from 'domain-review-history-lib';
import { GET_DOMAIN_REVIEW_HISTORY_QUERY } from '../__generated__/chirp/com/hubspot/domain/review/history/rpc/DomainReviewHistoryRpc.dfc.new';
export function getEmptyCombinedDomainReviewHistoryResponse() {
  return {
    assignmentHistory: {
      hasMore: false,
      offset: 0,
      results: []
    },
    domainReviewHistory: {
      companyReviewStats: {
        totalReviews: 0,
        uniqueReps: 0
      },
      companyReviews: []
    }
  };
}

// This function can be called in a card registry in order to fire a request
// before your JS has loaded and evaluated.
export const dataResolver = ({
  graphqlClient: __graphqlClient,
  dfcClient
}, {
  cardData: __cardData,
  additionalLocationData: {
    objectId,
    objectTypeId
  }
}) => {
  if (!objectId) {
    return Promise.resolve(getEmptyCombinedDomainReviewHistoryResponse());
  }
  const objectType = objectTypeId === '0-1' ? 'CONTACT' : 'COMPANY';

  // Execute both queries in parallel
  const assignmentHistoryPromise = dfcClient.query({
    query: GET_ASSIGNMENT_HISTORY,
    variables: {
      objectId,
      timestamp: Date.now(),
      objectType
    }
  }).then(result => result.data.assignmentHistory);
  const domainReviewHistoryPromise = dfcClient.query({
    query: GET_DOMAIN_REVIEW_HISTORY_QUERY,
    variables: {
      objectId,
      objectType
    }
  }).then(result => result.data.result);
  return Promise.all([assignmentHistoryPromise, domainReviewHistoryPromise]).then(([assignmentHistory, domainReviewHistory]) => ({
    assignmentHistory,
    domainReviewHistory
  }));
};